import { render, staticRenderFns } from "./Rule_Bingo.vue?vue&type=template&id=9533e8b6&scoped=true&"
import script from "./Rule_Bingo.vue?vue&type=script&lang=js&"
export * from "./Rule_Bingo.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Bingo.vue?vue&type=style&index=0&id=9533e8b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9533e8b6",
  null
  
)

export default component.exports